import { useEffect, Component } from "react";
import Lenis from "lenis";
import { MotionConfig } from "framer-motion";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import MarqueeBand from "./components/MarqueeBand";
import Work from "./components/Work";
import About from "./components/About";
import Contact from "./components/Contact";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  render() {
    if (this.state.error) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-[#050505] p-8 text-center">
          <p className="font-jbmono text-sm text-zinc-400">
            Something glitched. Refresh to reload the portfolio.
          </p>
        </div>
      );
    }
    return this.props.children;
  }
}

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.14, wheelMultiplier: 1.1, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <ErrorBoundary>
      <MotionConfig reducedMotion="user">
        <div className="grain relative min-h-screen bg-[#050505] text-white">
          <Navbar />
          <main data-testid="main-content" className="relative">
            <Hero />
            <MarqueeBand />
            <Work />
            <About />
          </main>
          <Contact />
        </div>
      </MotionConfig>
    </ErrorBoundary>
  );
}
